import React from 'react';
import { connect } from 'react-redux';

class TextArea extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			flag: true
		};
	}

	componentDidMount() {
		if (this.props.notMandatory && this.props.validateFields) {
			this.props.validateFields.push({ key: this.props.id, isValid: true, message: true, notMandatory: true })
			this.props.errorFn(this.props.validateFields)
		} else if (this.props.validateFields) {
			this.props.validateFields.push({ key: this.props.id, isValid: false, message: false })
			this.props.errorFn(this.props.validateFields)
		}
		if (this.props.value && this.props.value !== '') {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(this.props.id, false, false, true));
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value && nextProps.value !== '' && this.props.validateFields && this.state.flag) {
			this.props.errorFn(this.getValidateFileds(this.props.id, false, false, true));
			this.setState({ flag: false });
		}
	}

	loadTranslations = (value, currentLanguage) => {
		const currentLang = currentLanguage ? currentLanguage : 'en';
		return this.props.translations ? this.props.translations[value] ? this.props.translations[value][currentLang] ? this.props.translations[value][currentLang] : value : value : value;
	}

	onChangeText = (value, column) => {
		if (value === '' && this.props.notMandatory) {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, false, false, true));
			this.props.onChange(value, column);
			return true
		} else if (value === '' && !this.props.notMandatory) {
			const labelVal = column.charAt(0).toUpperCase() + column.slice(1);
			const lab = labelVal.split(/(?=[A-Z])/).join(" ");
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, lab, 'is required'));
			this.props.onChange(value, column);
			return true
		}
		if (value.length >= this.props.length) {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, `More than ${this.props.length} charcters not allowed`, false, true));
		} else {
			this.props.errorFn && this.props.errorFn(this.getValidateFileds(column, false, false, true));
			this.props.onChange(value, column);
		}
	}

	getValidateFileds = (column, message, message1, isValid) => {
		if (this.props.validateFields) {
			const fields = this.props.validateFields.map((data) => {
				if (data.key === column) {
					data['message'] = message
					data['message1'] = message1
					data['isValid'] = isValid
					return data
				} else {
					return data
				}
			})
			return fields
		} else {
			return this.props.validateFields
		}
	}

	getMessage = () => {
		let message = false;
		if (this.props.validateFields && this.props.isSubmit) {
			this.props.validateFields.map((data) => {
				if (data.key === this.props.id) {
					message = { message: data.message, message1: data.message1 }
				}
			})
		}
		return message
	}

	render() {
		return (
			<div>
				{this.props.label && <div className="login-input-text">{this.loadTranslations(this.props.label, this.props.currentLanguage)} {this.props.mandatory && '*'}</div>}
				{this.props.label && <div style={{ minHeight: 14 }}><div style={{ color: 'red', float: 'right', fontSize: 12, paddingBottom: 2 }}>{this.getMessage() && <span> <span>{this.loadTranslations(this.getMessage().message, this.props.currentLanguage)}</span> <span>{this.loadTranslations(this.getMessage().message1, this.props.currentLanguage)}</span></span>}</div></div>}
				<textarea placeholder={this.loadTranslations(this.props.placeholder || '', this.props.currentLanguage)}
					value={this.props.value}
					autoComplete="off"
					type={this.props.type ? this.props.type : 'text'}
					onChange={(e) => this.onChangeText(e.target.value, this.props.id)}
					id={this.props.id}
					onMouseLeave={() => this.props.onMouseLeave ? this.props.onMouseLeave(this.props.id) : {}}
					onBlur={(e) => this.props.onBlur ? this.props.onBlur(e.target.value) : {}}
					readOnly={this.props.readOnly}
					style={{ minHeight: this.props.minHeight || 'none', maxHeight: this.props.maxHeight || 'none', minWidth: this.props.minWidth || 'none', maxWidth: this.props.maxWidth || 'none' }}
				/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentLanguage: state.users.currentLanguage,
		translations: state.users.translations
	};
}

export default connect(mapStateToProps)(TextArea);



// WEBPACK FOOTER //
// ./screens/TextArea/TextArea.js